import { Box, Stack } from '@mui/material';
import { StoreResult } from 'api/client-domain/client-domain.types';
import SectionTitle from 'components/drawers/transaction-drawers/section-title/section-title.component';
import { useTranslation } from 'react-i18next';
import RelatedLocationCard from '../related-location-card/related-location-card.component';

type SecondaryLocationCardProps = {
  secondaryLocations: Partial<StoreResult[]>;
  onNavigate: (id: string) => void;
};

const SecondaryLocationSection = ({
  secondaryLocations,
  onNavigate,
}: SecondaryLocationCardProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <SectionTitle
        title={t(
          'drawer.relatedLocationsDrawer.sectionTitles.secondaryLocations',
        )}
      />
      <Stack spacing={2}>
        {secondaryLocations?.map(location => (
          <RelatedLocationCard
            relatedLocation={location}
            onNavigate={onNavigate}
            data-testid="Secondary.RelatedLocationCard"
          />
        ))}
      </Stack>
    </Box>
  );
};

export default SecondaryLocationSection;
